import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { LoraChart } from '../../../../assets/data/enum/loraChart.enum';
import { DeviceData } from '../../_models/deviceData';
import { LoraChartDataService } from './common/loraChartData.service';
import { ParamMetaDataMapperService } from '../paramMetaDataMapper.service';

@Injectable()
export class SenseService extends LoraChartDataService {
  private loraChartByProperty = {};

  constructor(
    private translate: TranslateService,
    private paramMetaDataMapper: ParamMetaDataMapperService
  ) {
    super();
  }

  addAllValuesToLoraDataSN(code: string, values: DeviceData, currentTime: number) {
    /* Standard Data */
    this.addValueToLoraChartData(code, LoraChart.RSSI, values.rssi, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.LiquidLevel, values.ll, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.LiquidTemperature, values.nt1, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.PH, values.ph, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SNR, values.snr, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.LeafWetness, values.lw, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.WM1, values.wm1, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.WM2, values.wm2, currentTime, true);
    /* SM */
    this.addValueToLoraChartData(code, LoraChart.SM1, values.sm1, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SM2, values.sm2, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SM3, values.sm3, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SM4, values.sm4, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SM5, values.sm5, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SM6, values.sm6, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SM7, values.sm7, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SM8, values.sm8, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SM9, values.sm9, currentTime, true);
    /* ST */
    this.addValueToLoraChartData(code, LoraChart.ST1, values.st1, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.ST2, values.st2, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.ST3, values.st3, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.ST4, values.st4, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.ST5, values.st5, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.ST6, values.st6, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.ST7, values.st7, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.ST8, values.st8, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.ST9, values.st9, currentTime, true);
    /* SS */
    this.addValueToLoraChartData(code, LoraChart.SS1, values.ss1, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SS2, values.ss2, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SS3, values.ss3, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SS4, values.ss4, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SS5, values.ss5, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SS6, values.ss6, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SS7, values.ss7, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SS8, values.ss8, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.SS9, values.ss9, currentTime, true);
    /* Other standard Data */
    this.addValueToLoraChartData(code, LoraChart.MR1, values.mr1, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.MR2, values.mr2, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.At, values.at, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.Atd, values.atd, currentTime, true);
    this.addValueToLoraChartData(code, LoraChart.Ah, values.ah, currentTime, true);
  }

  buildLoraGraphs(codeList: Array<string>) {
    for (const code of codeList) {
      const stringCode: string = code.toString();
      const SMChartArray = this.getMultipleLoraCharts(stringCode, LoraChart.SM, 9);
      const STChartArray = this.getMultipleLoraCharts(stringCode, LoraChart.ST, 9);
      const SSChartArray = this.getMultipleLoraCharts(stringCode, LoraChart.SS, 9);
      const MRChartArray = this.getMultipleLoraCharts(stringCode, LoraChart.MR, 2);

      this.loraChartByProperty = {};
      this.setSingleLoraGraphProperty(stringCode, LoraChart.RSSI, null);
      this.setSingleLoraGraphProperty(stringCode, LoraChart.SNR, null);
      this.setSingleLoraGraphProperty(stringCode, LoraChart.LeafWetness, null);
      this.setSingleLoraGraphProperty(stringCode, LoraChart.WM1, null);
      this.setSingleLoraGraphProperty(stringCode, LoraChart.WM2, null);
      this.setSingleLoraGraphProperty(stringCode, LoraChart.PH, null);
      this.setSingleLoraGraphProperty(stringCode, LoraChart.LiquidLevel, null);
      this.setSingleLoraGraphProperty(stringCode, LoraChart.LiquidTemperature, null);
      this.setSingleLoraGraphProperty(stringCode, LoraChart.At, '#397a95');
      this.setSingleLoraGraphProperty(stringCode, LoraChart.Atd, '#397a95');
      this.setSingleLoraGraphProperty(stringCode, LoraChart.Ah, '#397a95');

      this.setMultipleLoraGraphProperty(stringCode, LoraChart.SM, SMChartArray);
      this.setMultipleLoraGraphProperty(stringCode, LoraChart.ST, STChartArray);
      this.setMultipleLoraGraphProperty(stringCode, LoraChart.SS, SSChartArray);
      this.setMultipleLoraGraphProperty(stringCode, LoraChart.MR, MRChartArray);

      this.setLoraChartData(stringCode, LoraChart.AllByCode, this.loraChartByProperty);
    }
    return this.getLoraChart(LoraChart.AllByCode);
  }

  private setSingleLoraGraphProperty(code: string, loraChart: string, customColor: string) {
    const loraChartData = this.getLoraChartData(code, LoraChart.RSSI);
    if (loraChartData && loraChartData.length > 0) {
      this.loraChartByProperty[loraChart] = this.getLoraChartProperty(
        code,
        loraChart,
        loraChartData,
        customColor,
        true
      );
    }
  }

  private setMultipleLoraGraphProperty(code: string, loraChart: string, data: Array<any>) {
    if (data && data.length > 0) {
      this.loraChartByProperty[loraChart] = this.getLoraChartProperty(
        code,
        loraChart,
        data,
        null,
        false
      );
    }
  }

  private getLoraChartProperty(
    code: string,
    loraChart: string,
    loraChartData,
    customColor: string,
    single: boolean
  ) {
    const type: string = single ? 'single' : 'multiple';
    const color: string = customColor ? customColor : '#faab33';
    const res = {
      type,
      chart: {
        color,
        data: loraChartData,
        measurementUnit: this.paramMetaDataMapper.getScale(loraChart),
        title: this.translate.instant('chart.title.' + loraChart, {}),
        subtitle: this.getFormattedPeriod(loraChartData),
      },
    };
    if (!single) {
      delete res.chart.color;
    }
    return res;
  }

  private getFormattedPeriod(data) {
    if (data && data.length > 0) {
      const firstData = new Date(data[0][0]);
      const lastData = new Date(data[data.length - 1][0]);

      return (
        firstData.toLocaleString('it-IT', {}).substring(0, 10).replace(',', '') +
        ' - ' +
        lastData.toLocaleString('it-IT', {}).substring(0, 10).replace(',', '')
      );
    }
  }

  private getMultipleLoraCharts(code: string, loraChart: string, numberOfItems: number) {
    const res: Array<any> = [];
    for (let i = 1; i <= numberOfItems.valueOf(); i++) {
      const tmp = this.getLoraChartData(code, loraChart + i.toString());
      if (tmp) {
        res.push(tmp);
      }
    }
    return this.getMultipleDataArray(res, loraChart);
  }

  private getMultipleDataArray(loraChartDataArrays: Array<Array<any>>, loraChart: string) {
    const dataArray: Array<any> = [];
    let index = 1;
    for (const current of loraChartDataArrays) {
      if (current != null && current.length > 0) {
        dataArray.push({ name: loraChart + index, data: current });
      }
      index = index + 1;
    }
    return dataArray;
  }
}
